<template>
  <div class='SelectIcon'>
    <div class="top">
      <div class="label">Biblioteca de ícones:</div>
      <div class="close">
        <close-icon @click="SetModal({ active: false })"/>
      </div>
    </div>
    <div class="cont-icons">
      <div
      v-for="(i, key) in Object.values(icons).map(i => i.name)"
      :key="key"
      class="cont-icons-unit"
      >
        <component
        :is="i"
        :tam="'40px'"
        @click="set(i)"
        :count="false"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import CloseIcon from '../Icons/CloseIcon'
import { icons } from '@/components/icons'
export default {
  name: 'SelectIcon',
  components: { CloseIcon, ...icons },
  computed: {
    ...mapGetters(['EnbModal'])
  },
  data () {
    return {
      icons: icons
    }
  },
  methods: {
    ...mapActions(['SetModal', 'SetIcon', 'UpdatePrefComp']),
    set (icon) {
      if(this.EnbModal.callback === 'SetIcon') {
        this.SetIcon(icon)
          .then(() => {
            this.SetModal({ active: false })
          })
        return
      }
      if(this.EnbModal.callback === 'UpdatePrefComp') {
        this.UpdatePrefComp({ comp: 'cart', prop: 'icon', value: icon })
          .then(() => {
            this.SetModal({ active: false })
          })
        return
      }
    } 
  }

}
</script>

<style scoped>
.SelectIcon {
  width: 50%;
  height: 70%;
  position: absolute;
  margin: auto;
  background-color: #FFFFFF;
  border-radius: 5px;
  overflow: hidden;
}

.top {
  display: flex;
  padding: 2%;
  background-color: #CCCCCC;
}

.label {
  width: 95%;
  text-align: left;
}

.close {
  width: 5%;
  text-align: right;
}

.cont-icons {
  display: flex;
  padding: 2%;
  flex-wrap: wrap;
}

.cont-icons-unit {
  margin: 1.5%;
}
</style>
